<template src="./index.html">

</template>
<script>
import com from '../../../../../comMapping.js';
import { getdata } from './data'
export default{
  props:{
    HistoricalDiag:{
      type:Boolean,
      default:false,
    },
    dataList:{
      type:Object,
      default:{}
    }
  },
  data(){
    return{
      headData:getdata().headData,
      tableData:[{}],
      pagination:getdata().pagination,
      param:{
        docStatus: com.lqdjzt.map(item => item.code),
				invoiceType: com.lqfplx.map(item => item.code),
        invoiceNumber:'',
      },
      order: '',
			//排序顺序
			sort: '',
			//筛选字段
    }
  },
  methods:{
    page(){
      let params = {}
        this.param.invoiceNumber = this.dataList.invoiceNumber
        params.limit = this.pagination.pageSize
			  params.page = this.pagination.pageNum
        params.param = this.param
        params.sort = this.sort;
			  params.order = this.order;
        this.$https.fetchPost('/natural/codeAssignment/findCodeAssignmentRecords', params).then(res=>{
          this.tableData = res.data.data;
				  this.pagination.total = res.data.count;
        })
    },
    sortchange(e) {
			if (e.order != null) {
				this.sort = e.order == 'ascending' ? 'ASC' : 'DESC';
				this.order = e.prop;
			} else {
				this.sort = '';
				this.order = '';
			}
			this.page();
		}, //筛选数组
    forSearchScreeningBox(obj) {
			this.param.docStatus = obj.docStatus;
			this.param.invoiceType = obj.invoiceType;
			this.page();
		},
    closediag() {
			this.$emit('closediag', false);
		}
  }
}
</script>
<style scoped>
@import url('./index.less');
</style>
